export const YAKIT_FORCE_SET_PREVIEW_KEY = 'yakit_force_set_preview' as const;
export const CONSTRUCTOR_KEY = 'constructor' as const;
export const CONSTRUCTOR_MYSTIQUE_KEY = 'constructor_mistique' as const;
export const SHOP_SEO_DESCRIPTION_KEY = 'seo.generation.shop_description' as const;
export const CALL_ME_BANNER = 'call_me_banner' as const;
export const DASHBOARD_TODO_LIST_MAIN_EXPANDED_KEY = 'dashboard_todo_list_main_expanded' as const;
/** RUM DashboardTodoList: список уже показывался пользователю хотя бы раз */
export const DASHBOARD_TODO_LIST_SHOWN_KEY = 'dashboard_todo_list_shown' as const;

export const DASHBOARD_NEWS_SEEN_UNREAD_COUNT_KEY = 'dashboard_news.seen_unread_count' as const;
export const DASHBOARD_NEWS_POPUP_HIDDEN_KEY = 'dashboard_news.popup_hidden' as const;
export const DASHBOARD_ALERTS_COOLDOWN_KEY = 'dashboard_alerts.cooldown' as const;
export const PROMO_CALENDAR_DISMISSED_RECOMMENDATIONS_KEY = 'dashboard.promoRecommendations.dismissed' as const;
/** Раскрытие аккордеона календаря на вкладке автоматических скидок */
export const PROMOACTIONS_DISCOUNT_TAB_TIMELINE_EXPANDED_KEY = 'promoactions.discountTab.timelineExpanded' as const;
/** Чекбокс «Показать акции из Рекомендаций» на вкладке автоматических скидок */
export const PROMOACTIONS_DISCOUNT_TAB_SHOW_RECOMMENDATIONS_KEY =
    'promoactions.discountTab.showRecommendations' as const;
export const SETTINGS_DOMAIN_WELCOME_STEP_DISMISSED_STORAGE_KEY = 'settings.domain.welcomeStepDismissed' as const;
/** Признак того, что продавец выключал апселл на чекауте (для события повторного включения) */
export const SETTINGS_ORDER_UPSELL_DISABLED_STORAGE_KEY = 'settings.order.upsellDisabled' as const;

export const FEATURE_HINT_DASHBOARD_TODO_TITLE_KEY = 'feature_hint.dashboard_todo_list.title' as const;
export const FEATURE_HINT_DASHBOARD_TODO_COMPLETION_ICON_KEY =
    'feature_hint.dashboard_todo_list.completion_icon' as const;
export const FEATURE_HINT_DASHBOARD_TODO_NEW_LABEL_KEY = 'feature_hint.dashboard_todo_list.new_label' as const;
export const FEATURE_HINT_THEME_SWITCHER_DISMISSED_KEY = 'feature_hint.theme_switcher.dismissed' as const;

/** Видимые колонки грида вариантов на дашборде товаров (JSON-массив id колонок) */
export const PRODUCT_VARIANTS_GRID_VISIBLE_COLUMN_IDS_KEY =
    'yastore-b2b.products-dashboard.variant-grid.visible-column-ids.v2' as const;

/** Видимые колонки грида архивных вариантов на дашборде товаров (JSON-массив id колонок) */
export const ARCHIVED_PRODUCT_VARIANTS_GRID_VISIBLE_COLUMN_IDS_KEY =
    'yastore-b2b.products-dashboard.archived-variant-grid.visible-column-ids' as const;

/** Видимые колонки грида карточек на дашборде товаров (JSON-массив id колонок) */
export const PRODUCT_CARDS_GRID_VISIBLE_COLUMN_IDS_KEY =
    'yastore-b2b.products-dashboard.cards-grid.visible-column-ids' as const;

/** Видимые колонки грида товаров на проверке на дашборде товаров (JSON-массив id колонок) */
export const PRODUCT_MODERATION_VARIANTS_GRID_VISIBLE_COLUMN_IDS_KEY =
    'yastore-b2b.products-dashboard.moderation-variants-grid.visible-column-ids' as const;

/** Видимые колонки грида заказов (JSON-массив id колонок) */
export const ORDERS_GRID_VISIBLE_COLUMN_IDS_KEY = 'yastore-b2b.orders-grid.visible-column-ids' as const;

/** Видимые колонки грида ABC-анализа (JSON-массив id колонок) */
export const ABC_GRID_VISIBLE_COLUMN_IDS_KEY = 'yastore-b2b.abc-grid.visible-column-ids' as const;

export const ASYNC_PROCESS_MONITOR_FILTERS_KEY = 'asyncProcessMonitor.filters' as const;
